// icons/travel.svg

export const TravelIconV2 = (props) => (
  <svg
    className={props.className}
    width="33"
    height="35"
    viewBox="0 0 33 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.57837 12.3999H27.8784C30.7068 12.3999 32.9784 14.6715 32.9784 17.4999C32.9784 20.1832 30.6508 22.3999 27.8784 22.3999H1.57837V12.3999ZM4.57837 15.3999V19.3999H27.8784C29.1059 19.3999 29.9784 18.4166 29.9784 17.4999C29.9784 16.3283 29.0499 15.3999 27.8784 15.3999H4.57837Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3784 0H18.2548L24.9827 15.2H12.3784V0ZM15.3784 3V12.2H20.3741L16.302 3H15.3784Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3784 19.3999H24.9827L18.2548 34.5999H12.3784V19.3999ZM15.3784 22.3999V31.5999H16.302L20.3741 22.3999H15.3784Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 10.5534L2.50837 9.20947L6.10837 12.6095L6.32651 14.532L3.92651 18.132L1.2 17.5534L0 10.5534Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.2 17.0466L3.92651 16.468L6.32651 20.068L6.10837 21.9906L2.50837 25.3906L0 24.0466L1.2 17.0466Z"
      fill="#34363E"
    />
  </svg>
);
